import React from 'react';
import classnames from 'classnames';
import { LoadingOutlined } from '@ant-design/icons';
import cn from './styles.module.scss';

type LoaderProps = {
  text?: string;
  hideText?: boolean;
  className?: string;
};

export const Loader = ({ text = 'Loading', hideText, className = '' }: LoaderProps) => (
  <div data-testid='LoaderIcon' className={classnames(cn.loader, className)}>
    {!hideText && (<span>{text}</span>)}
    <LoadingOutlined />
  </div>
);
